<template>
    <div>
        <div class="page-content-ptb">
            <div class="orderRecord-tabWrap">
                <div class="orderRecord-tab js-tab" :class="{ active: status == 'all'}"  @click="status='all'"
                data-el="orderRecord1" data-box="orderRecord-wrap">
                    <div class="orderRecord-tab-box">全部订单</div>
                </div>
                <div class="orderRecord-tab js-tab" :class="{ active: status == 'noPaid'}" @click="status='noPaid'"
                data-el="orderRecord2" data-box="orderRecord-wrap">
                    <div class="orderRecord-tab-box">
                        待付款订单
                        <p class="orderRecord-tab-badge" v-show="pageData.noPaid.length > 0">{{pageData.noPaid.length}}</p>
                    </div>
                </div>
                <div class="orderRecord-tab js-tab" :class="{ active: status == 'paid'}" @click="status='paid'"
                data-el="orderRecord3" data-box="orderRecord-wrap">
                    <div class="orderRecord-tab-box">已付款订单</div>
                </div>
            </div>
            <div class="order-box">
              <div class="order-box-text">
                您可使用订单号、航次、乘客信息进行关联预订、预订行前订产品、查看和修改订单信息等。
                <div class="to-searh" @click="gotoSearch">
                  <img :src="imgUrl+'/bookingSearch/search.png'" class="to-searh-img" />
                  <span class="to-searh-text">查询其他平台预订</span>
                </div>

              </div>
            </div>
            <div class="orderRecord-wrap">
                <div class="tab-cell" id="orderRecord1">
                    <div class="no_booking_tips" v-show="isFinishLoading && pageData[status].length == 0">您还没有相关订单哦</div>
                    <BookingListItem
                        v-for="(order, i) in pageData[status]"
                        :key="i"
                        :order="order"
                        :selectedBooking="selectedBooking"
                        :selectedOpenBooking="selectedOpenBooking"
                        :onBookingSelected="onBookingSelected"
                        :onOpenBookingSelected="onOpenBookingSelected"
                        :onQiaohuRoomClicked="showQiaohuPopup"
                        :onStarrySkyClicked="showStarrySkyPopup"
                        :onCustomThemeClicked="showCustomThemePopup"
                        :onConnectRoomClicked="showConnectRoomPopup"
                        :orderItem="order"
                        :userDetail="userDetail"
                        @showInvoiceList="showInvoiceList"
                    />
                </div>
            </div>
        </div>

        <BookingListBottom
            v-show="isShowBottomBar"
            :selectedBooking="selectedBooking"
            :selectedOpenBooking="selectedOpenBooking"
        />

        <QiaohuPopup
            :shipCode="targetShipCode"
            :sailDate="targetSailDate"
            :onGoBack="closeQiaohuPopup"
            :isShow="isShowQiaohuPopup"
        />

        <StarrySkyPopup
            :shipCode="targetShipCode"
            :sailDate="targetSailDate"
            :onGoBack="closeStarrySkyPopup"
            :isShow="isShowStarrySkyPopup"
        />

        <CustomThemePopup
            :onGoBack="closeCustomThemePopup"
            :isShow="isShowCustomThemePopup"
            :themeInfo="personalizedStateroomInfo"
        />

        <ConnectRoomPopup
            :onGoBack="closeConnectRoomPopup"
            :isShow="isShowConnectRoomPopup"
        />

        <EmergencyMessageAlert />
      <BottomPopup :show="isShowInvoiceList"
                   title="请选择合并开票的订单"
                   @close="isShowInvoiceList=false"
      >
      <div class="invoice-list">
        <div class="list-con">
          <div class="invoice-list-item" v-for="(i,idx) in invoiceBookingList" :key="idx">
            <div class="item-header">
              <div class="route-info-hook"
                   @click="onSelectInvoice(i.encBookingRecordId)">
                <img v-if="isInvoiceSelected(i.encBookingRecordId)" src="https://resource.rcclchina.com.cn/invoice/invoice-select.png" alt="">
                <img v-else src="https://resource.rcclchina.com.cn/invoice/invoice-noSelect.png" alt="">
              </div>
              <div>订单号：{{ i.bookingId }}</div>
            </div>
            <div class="item-main">
              <div class="item-main-img">
                <img :src="i.stateroomImage" alt="">
              </div>
              <div class="item-main-info">
                <div class="info-route-name">{{i.cruiseRoute}}</div>
                <div class="info-route-date">{{getDateRange(i.sailDate)}} ~ {{getDateRange(i.sailReturnDate)}}</div>
                <div class="info-route-price">{{i.currencyIcon}}{{i.amount}}</div>
                <div class="info-route-guest">{{ i.gusetsNameStr.join(',') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-list-footer">
          <div class="footer-right-btn" @click="goInvoicePage">
            开票
          </div>
        </div>
        <div class="invoiceTips" v-show="isShowInvoiceTips">
          请勾选合并开票的订单
        </div>
      </div>
      </BottomPopup>
    </div>
</template>

<script>
import api from '@/api'
import bookingStatusHelper from '@/utilities/bookingStatusHelper'
import StarrySkyPopup from "@/components/Cruise/StarrySkyPopup.vue";
import BottomPopup from "@/components/Booking/BottomPopup.vue";
const BookingListItem = () => import('@/components/Booking/BookingListItem.vue')
const BookingListBottom = () => import('@/components/Booking/BookingListBottom.vue')
const QiaohuPopup = () => import('@/components/Cruise/QiaohuPopup')
const ConnectRoomPopup = () => import('@/components/Cruise/ConnectRoomPopup')
const CustomThemePopup =()=> import("@/components/Cruise/CustomThemePopup.vue")
const EmergencyMessageAlert = () => import("@/components/Home/EmergencyMessageAlert");
export default {
    name: 'BookingList',
    components: {
      BottomPopup,
      StarrySkyPopup,
        BookingListItem,
        QiaohuPopup,
        ConnectRoomPopup,
        BookingListBottom,
        CustomThemePopup,
        EmergencyMessageAlert
    },
    beforeMount() {
        this.$store.commit('SET_PAGE_TITLE', '订单页')
        const query = this.$router.currentRoute.query
        if (query && query.sort == 2) {
            this.status = 'noPaid'
        } else if (query && query.sort == 3) {
            this.status = 'paid'
        }
        console.log('query', query)

        if(query && query.isRow){
         this.isRow = query.isRow
        }

        this.initPage()
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: true})
        window.onpopstate = () => {
            if (this.isShowQiaohuPopup) {
                this.closeQiaohuPopup()
            }
            if (this.isShowStarrySkyPopup) {
              this.closeStarrySkyPopup()
            }
            if (this.isShowConnectRoomPopup) {
                this.closeConnectRoomPopup()
            }
            if (this.isShowCustomThemePopup) {
              this.closeCustomThemePopup()
            }
        }
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
        window.onpopstate = () => {}
    },
    data () {
        return {
            pageData: {
                all: [],
                noPaid: [],
                paid: []
            },
            selectedBooking: [],
            selectedOpenBooking: [],
            targetShipCode: '',
            targetSailDate: '',
            status: 'all',
            isFinishLoading: false,
            isShowQiaohuPopup: false,
            isShowConnectRoomPopup: false,
            userDetail:'',
            isShowStarrySkyPopup: false,
            isShowInvoiceList:false,
            bookingRecordIds:[],
            invoiceBookingList:null,
            imgUrl : 'https://resource.rcclchina.com.cn/wechatMiniProgram',
            isShowInvoiceTips:false, // 显示合并开票的提示
            isShowCustomThemePopup:false,
            personalizedStateroomInfo:null,
            isRow:false
        }
    },
    methods: {
        gotoSearch(){
          this.$router.push({ name: 'BookingSearch' })
        },
        async initPage () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.$router.push({ name: 'Login', query:{
                    returnUrl: encodeURIComponent(location.href)
                }})
            }
            const storedBookingList = this.$store.state.booking.bookingList
            if (storedBookingList) {
                this.getBookingListSuccessHandler(storedBookingList)
                this.isFinishLoading = true
            } else {
                this.$loading.show()
                const { success, data, errMsg } = await api.booking.bookingList({
                  offset: 0,
                  limit: 100,
                  type:Number(this.isRow)
                })
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                    return
                }
                if (data && data.userCenterBookings) {
                    this.getBookingListSuccessHandler(data.userCenterBookings)
                    this.$store.commit('SET_BOOKING_LIST', data.userCenterBookings)
                    this.isFinishLoading = true
                }
            }
            this.$loading.show();
            let userDetail = await api.user.getUserDetail(userToken);
            this.userDetail = userDetail.data;
            this.$loading.hide();
        },
        getBookingListSuccessHandler (bookingList) {
            bookingList.forEach(order => {
              order.isAllCancelled = order.bookingItems.length > 0 ? order.bookingItems.filter(r=>r.bookingStatus==='CANCELLED').length === order.bookingItems.length : false;
            })
            this.pageData = {
                all: this.getBookingsByStatus('all', bookingList),
                noPaid: this.getBookingsByStatus('noPaid', bookingList),
                paid: this.getBookingsByStatus('paid', bookingList)
            }
        },
        // 根据状态获取订单
        // staus: all, noPaid, paid
        getBookingsByStatus(status, bookingList) {
            if (status == 'all') {
                // tabs-全部订单
                return bookingList
            } else {
                this.$loading.show()
                let statusList = []
                let openBookingStatusList = []
                if (status == 'noPaid') {
                    // tabs-待付款订单
                    openBookingStatusList = ['unpaid']
                    statusList = ['Not_Payment', 'Not_Full_Payment']
                } else if (status == 'paid') {
                    // tabs-已付款订单
                    openBookingStatusList = ['paid', 'confirmed']
                    statusList = ['UnSail', 'SAILED']
                }

                let result = []
                const curDate = new Date()
                bookingList.forEach((order)=> {
                    if (order.bookingItems) {
                        let items = []
                        order.bookingItems.forEach((booking) => {
                          if(bookingStatusHelper.isOpenBooking(booking)){
                            // openbooking 订单
                            const bookingStatus = bookingStatusHelper.getBookingStatus(booking)
                            if(openBookingStatusList.indexOf(bookingStatus) >= 0){
                              if (bookingStatus == 'unpaid') {
                                const sailDate = new Date(booking.sailDate)
                                const openBookingEndDate = new Date(booking.openBookingEndDate)
                                if (openBookingEndDate > curDate || sailDate > curDate) {
                                items.push(booking)
                                }
                              } else {
                                items.push(booking)
                              }
                            }
                            
                          }else{
                            // 非 openbooking 订单
                            if(statusList.indexOf(booking.bookingBusinessStatus.paymentStatusCode) >= 0){
                                items.push(booking)
                              }
                            }
                          
                          })
                        if (items.length > 0) {
                            result.push({
                                shoppingCartOrderId: order.shoppingCartOrderId,
                                createdDate: order.createdDate,
                                bookingItems: items
                            })
                        }
                    }
                })

                this.$loading.hide()
                return result
            }
        },
        onBookingSelected (booking) {
            if (this.selectedBooking.some(r=>r.bookingRecordId == booking.bookingRecordId)) {
                // 反选
                this.selectedBooking = this.selectedBooking.filter(r=>r.bookingRecordId != booking.bookingRecordId)
            } else {
                if (booking.bookingBusinessStatus.shouldPayBalanceOnline == true) {
                    this.selectedBooking.push(booking)
                    this.selectedOpenBooking = []
                }
            }
        },
        onOpenBookingSelected (booking) {
            // opbk目前只支持单选，不支持多选
            if (this.selectedOpenBooking.length > 0
                && this.selectedOpenBooking[0].openBookingOrderId == booking.openBookingOrderId) {
                this.selectedOpenBooking = []
            } else {
                this.selectedOpenBooking = [booking]
            }
            this.selectedBooking = []
        },
        showQiaohuPopup (booking) {
            this.targetShipCode= booking.shipCode
            let sailDate = booking.sailDate
            if (sailDate.length > 10) {
                sailDate = sailDate.substring(0, 10)
            }
            this.targetSailDate = sailDate
            this.isShowQiaohuPopup = true
            this.showPopup()
        },
        closeQiaohuPopup () {
            this.isShowQiaohuPopup = false
        },
        showStarrySkyPopup(booking) {
          this.targetShipCode= booking.shipCode
          let sailDate = booking.sailDate
          if (sailDate.length > 10) {
            sailDate = sailDate.substring(0, 10)
          }
          this.targetSailDate = sailDate
          this.isShowStarrySkyPopup = true;
        },
        closeStarrySkyPopup() {
          this.isShowStarrySkyPopup = false;
        },
        showCustomThemePopup(booking) {
          this.personalizedStateroomInfo = booking.personalizedStateroomInfo;
          this.isShowCustomThemePopup = true;
        },
        closeCustomThemePopup() {
          this.isShowCustomThemePopup = false;
        },
        showConnectRoomPopup () {
            this.isShowConnectRoomPopup = true
            this.showPopup()
        },
        closeConnectRoomPopup () {
            this.isShowConnectRoomPopup = false
        },
        showPopup() {
            history.pushState({ page: 'bookingList' }, null);
        },
        showInvoiceList(booking){
          this.isShowInvoiceList = true
          this.bookingRecordIds.push(booking.encBookingRecordId)
          this.getInvoiceList()
        },
        // 获取可开发票列表
        async getInvoiceList() {
          if(this.invoiceBookingList&&this.invoiceBookingList.length>0)return
          this.$loading.show()
          let {data, success, errMsg} = await api.booking.getInvoiceBookingList({userName:this.$store.state.user.userToken})
          this.$loading.hide()
          if(success){
            if(data){
              data.forEach(item=>{
                let gusetsName = []
                item.guests.forEach(guest=>{
                  //   取出guest里面的guestName放到item里面
                  gusetsName.push(guest.guestName)
                })
                item.gusetsNameStr = gusetsName
              })
              this.invoiceBookingList = data
            }
          }else{
            this.$alert.show(errMsg)
          }
        },
        // 是否选中当前发票
        isInvoiceSelected(encBookingRecordId){
          return this.bookingRecordIds.some(r=>r===encBookingRecordId)
        },
        // 勾选发票
        onSelectInvoice(encBookingRecordId){
          if(this.bookingRecordIds.length===0){
            this.bookingRecordIds.push(encBookingRecordId)
          }else{
            this.bookingRecordIds.forEach(item=>{
              if(item===encBookingRecordId){
                this.bookingRecordIds.splice(this.bookingRecordIds.indexOf(item),1)
              }else{
                this.bookingRecordIds.push(encBookingRecordId)
              }
            })
          }
        },
        goInvoicePage(){
          if(this.isShowInvoiceTips) return
          if(this.bookingRecordIds.length<1){
            this.isShowInvoiceTips = true
            setTimeout(()=>{
              this.isShowInvoiceTips = false
            },1500)
          }else{
            this.$router.push({
              path: '/Rccl.Booking/Booking/InvoiceDetails',
              query: {
                bookingRecordIds:this.bookingRecordIds.join(',')
              }
            })
          }
        },
      getDateRange(dateTimeString) {
        let date = new Date(dateTimeString);
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
      },
    },
    computed: {
        isShowBottomBar () {
            return (this.selectedBooking.length > 0 || this.selectedOpenBooking.length > 0)
                && (this.status == 'all' || this.status == 'noPaid')
        }
    }
}
</script>

<style lang="less" scoped>

.orderRecord-tabWrap {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    height: 46px;
    margin-bottom: 10px;
    padding: 0 10px;
    -webkit-box-shadow: 0 1px 2px 0 #D6D7D8;
    box-shadow: 0 1px 2px 0 #D6D7D8;
    background-color: #fff;
}

.orderRecord-tab {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px;
    line-height: 1;
    color: #666;
}

.orderRecord-tab-box {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
}

.orderRecord-tab-badge {
    min-width: 16px;
    min-height: 16px;
    margin: 0;
    padding: 2px;
    font-size: 12px;
    line-height: 12px;
    color: #fff;
    text-align: center;
    background-color: #FF5055;
    border-radius: 20px;
}

.orderRecord-tab.active {
    color: #4A90E2;
    font-weight: bold;
}

.orderRecord-tab.active .orderRecord-tab-box::after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #4A90E2;
}

.no_booking_tips {
    text-align: center;
    top: 35vh;
    position: relative;
    font-size: 16px;
}
.QIAOHU_CSS {
    background-size: 100% 100%;
    width: 113px;
}
.ConnectIcon_css {
    background-size: 100% 100%;
    width: 113px;
}
.tab-cell{
  padding-bottom: 10px;
}
.invoice-list{
  //margin-top: 18px;
  box-sizing: border-box;
  position: relative;
  padding: 0 15px;
  .list-con{
    max-height: 400px;
    overflow: auto;
    color: #282828;
    border-top: 1px solid #E6E6E6;
    &::-webkit-scrollbar {
      display: none;
    }
    .invoice-list-item:first-child{
      border-top: none;
    }
    .invoice-list-item{
      padding: 10px 10px;
      border-top: 1px solid #E6E6E6;
      .item-header{
        font-weight: 500;
        font-size: 14px;
        color: #282828;
        display: flex;
        align-items: center;
        gap: 4px;
        .route-info-hook {
          width: 16px;
          height: 16px;
        }
        .route-info-hook img {
          width: 100%;
        }
      }
      .item-main{
        display: flex;
        align-items: center;
        gap: 7px;
        padding:  6px 0 0 22px;
        .item-main-img{
          width: 100px;
          height: 100px;
          border-radius: 8px;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .item-main-info{
          color: #000000;
          font-size: 14px;
          .info-route-name{
            width: 170px;
          }
          .info-route-date{
            font-size: 11px;
            color: #999999;
          }
          .info-route-guest{
            color: #4A4A4A;
            font-size: 12px;
          }
        }
      }
    }
  }
  .invoice-list-footer{
    display: flex;
    align-items: center;
    gap: 9px;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 12px;
    div{
      width: 100%;
      height: 39px;
      line-height: 39px;
      text-align: center;
      color: #333333;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      border-radius: 4px;
    }
    .footer-left-btn{
      background-color: #f5f5f5;
      color: #666666;
    }
    .footer-right-btn{
      color: #FFFFFF;
      background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
    }
  }
  .invoiceTips{
    width: 318px;
    height: 64px;
    background-color: rgba(32, 32, 32, 0.58);
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    line-height: 64px;
  }
}

.order-box{
  padding: 0 10px;
  margin-bottom: 10px;
}
.order-box-text{
  font-weight: 400;
  font-size: 10px;
  color: #9B9B9B;
  line-height: 1.2;
  margin-bottom: 5px;
}

.to-searh {
  width: 100%;
  height: 30px;
  background: #FFFFFF;
  border-radius: 5px;
  margin: 5px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9B9B9B;
}
.to-searh-img {
  width: 16px;
  height: 16px;
  margin-right: 7px;
}
.to-searh-text {
  font-weight: 400;
  font-size: 12px;
  color: #9B9B9B;
}
</style>
